// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1RVCo","amount":"Amount_amount__1JAZC","tip":"Amount_tip__2gQbS","tipHeader":"Amount_tipHeader__2EEFP","tipsWrap":"Amount_tipsWrap__19Ou7"};